module.exports = __webpack_public_path__ + "static/media/online_otp_photo.71ca3cff.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_otp_photo.jpeg
// module id = 308
// module chunks = 0